import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "16",
      height: "14",
      x: "4",
      y: "5",
      stroke: "currentColor",
      "stroke-width": "1.75",
      rx: "3"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "8.4",
      cy: "10",
      r: "1.8",
      stroke: "currentColor",
      "stroke-width": "1.75"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.75",
      d: "M6.3 14.1c.72-1.05 1.42-1.58 2.1-1.58.68 0 1.38.53 2.1 1.58M13.2 9.3h3.9M13.2 12h3.9m-3.9 2.7h2.5"
    }, null, -1)
  ]))]))
}
export default { render: render }